import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

/**
 * Visible KPI scope / freshness (design-review #3, #79).
 */
const DashboardScopeBar = ({
    periodLabel = '90 Days',
    asOf = null,
    scopeNote = null,
    dateRangeLabel = null,
    testId = 'dashboard-scope-bar',
}) => {
    const asOfLabel = asOf
        ? new Date(asOf).toLocaleString()
        : new Date().toLocaleString();

    return (
        <Box
            data-testid={testId}
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: 1,
                mb: 2,
            }}
        >
            <Chip size="small" label={`Period: ${periodLabel}`} variant="outlined" />
            {dateRangeLabel ? (
                <Typography
                    variant="caption"
                    color="text.secondary"
                    data-testid="dashboard-scope-bar-resolved-dates"
                >
                    {dateRangeLabel}
                </Typography>
            ) : null}
            <Typography variant="caption" color="text.secondary">
                As of {asOfLabel}
            </Typography>
            {scopeNote && (
                <Typography variant="caption" color="text.secondary" sx={{ flex: '1 1 100%' }}>
                    {scopeNote}
                </Typography>
            )}
        </Box>
    );
};

export default DashboardScopeBar;
